/*
 * 配置文件
 *
 * (c) 2018/6/23 lihaozhou
 * Email: lihaozhou@wps.cn
 * License: KSO
 */
export default {
  isDebug: false,
  version: '1.2.1'
}
